import React, { useEffect, useRef, useState } from "react";
import { Modal } from "react-bootstrap";
import { IoClose } from 'react-icons/io5'
import { CgDanger } from 'react-icons/cg'
import Toast from './../components/toast'

export default function AcceptRequestModal(props) {

    var [saveInFavorite, setSaveInFavorite] = useState(false);
    var [title, setTitle] = useState("");

    const handleChange = (e) => {
        setTitle(e.target.value)
    }
    var acceptBtn = useRef()

    useEffect(() => {
        setSaveInFavorite(false)
        setTitle("")
        acceptBtn?.current?.focus()
    }, [props])

    const handleClose = () => {
        props?.onClose();
    }

    const handleAccept = () => {
        if (!title && saveInFavorite) {
            Toast.Error("عنوان مقصد منتخب وارد نشده است")
            return
        }
        props?.onAccept(saveInFavorite, title);
    }
    var onSaveChecked = (e) => {
        console.log(e.target.checked)
        setSaveInFavorite(e.target.checked)
    }


    return (<>
        <div>

            <Modal show={props.show} onHide={handleClose} centered size="md">

                <Modal.Body >
                    <div className="justify-content-center align-items-center  position-relative d-flex row px-3  " >

                        <CgDanger className=" mb-3 text-warning" size={100} />
                        <h3>آیا از ثبت این سرویس اطمینان دارید؟</h3>

                        {props.showAddFavorite ? <div >
                            <input className="form-check-input ms-2" type="checkbox" value="" checked={saveInFavorite} onChange={onSaveChecked} id="flexCheckDefault" />
                            <label className="form-check-label" htmlFor="flexCheckDefault" >
                                در مقصد های پرتکرار ذخیره شود
                            </label>

                        </div> : <></>}

                        <div className="px-2 mt-2 col-12 ">
                            {saveInFavorite ? <input onChange={handleChange} name="title" className="card p-2  col-12 " placeholder="نام نمایشی مقصد (اجباری)" /> : <></>}
                        </div>

                        <div className="row mt-3 p-0 m-0">

                            <button className="btn btn-success col m-2 " onClick={handleAccept} ref={acceptBtn} ><h4 className="m-0 p-1 text-center">بله ثبت شود</h4></button>
                            <button className="btn btn-danger col  m-2" onClick={handleClose} ><h4 className="m-0 p-1 text-center">فعلا نه</h4></button>

                        </div>

                    </div>

                </Modal.Body>

            </Modal>


        </div>

    </>)
}
